<template>
  <div class="app-header header-shadow">
    <div class="app-header__logo">
      <div class="logo-src"></div>
      <div class="header__pane ml-auto">
        <div>
          <button
            type="button"
            class="hamburger close-sidebar-btn hamburger--elastic"
            data-class="closed-sidebar"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">
      <span>
        <button
          type="button"
          class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        >
          <span class="btn-icon-wrapper">
            <i class="fa fa-ellipsis-v fa-w-6"></i>
          </span>
        </button>
      </span>
    </div>
    <div class="app-header__content">
      <div class="app-header-right ml-md-auto ml-0">
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left">
                <div class="btn-group">
                  <button
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    class="p-0 btn btn-link"
                  >
                    <span class="icon-wrapper icon-wrapper-alt rounded-circle">
                      <span class="icon-wrapper-bg bg-alternate"></span>
                      <i class="fas fa-user text-alternate"></i>
                    </span>
                  </button>
                  <div
                    tabindex="-1"
                    role="menu"
                    aria-hidden="true"
                    class="rm-pointers dropdown-menu-lg dropdown-menu dropdown-menu-right"
                  >
                    <div class="dropdown-menu-header">
                      <div class="dropdown-menu-header-inner bg-info">
                        <div
                          class="menu-header-image opacity-2"
                          style="background-image: url('assets/images/dropdown-header/city3.jpg');"
                        ></div>
                        <div class="menu-header-content text-left">
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left mr-3">
                                <i class="fas fa-user rounded-circle"></i>
                              </div>
                              <div class="widget-content-left">
                                <div class="widget-heading" v-if="user">{{user.nombre}}</div>
                                <div class="widget-subheading opacity-8" v-if="user">{{user.tipo}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul class="nav flex-column">
                      <li class="nav-item-btn text-center nav-item">
                        <button @click="logout" class="btn-pill btn-shadow btn-shine btn btn-danger">Cerrar sesión</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="widget-content-left header-user-info ml-2">
                <div class="widget-heading" v-if="user">{{user.nombre}}</div>
                <div class="widget-subheading opacity-8" v-if="user">{{user.tipo}}</div>
                <!-- <div class="widget-subheading">Administrador</div> -->
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "HeaderComponent",
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  mounted() {
    // Search wrapper trigger
    $(".search-icon").click(function () {
      $(this).parent().parent().addClass("active");
    });
    $(".search-wrapper .close").click(function () {
      $(this).parent().removeClass("active");
    });
    $(".close-sidebar-btn").click(function () {
      var classToSwitch = $(this).attr("data-class");
      var containerElement = ".app-container";
      $(containerElement).toggleClass(classToSwitch);

      var closeBtn = $(this);

      if (closeBtn.hasClass("is-active")) {
        closeBtn.removeClass("is-active");
      } else {
        closeBtn.addClass("is-active");
      }
    });
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/logout",
    }),
    logout() {
      this.logoutAction().then(() => {
        this.$router.push({
          name: "Login",
        });
      });
    },
  },
};
</script>